import logo from "../assets/images/logos/logo.png";
import logo1 from "../assets/images/logos/logo1.png";
import headerLogo from "../assets/images/headerLogo/logo1x.png";
import searchIcon from "../assets/images/searchIcon/searchIcon.gif";
import product01 from "../assets/images/ProductImages/product01.png";
import imageUpload from "../assets/images/searchIcon/imageUpload.png";
import needHelp from "../assets/images/searchIcon/needHelp.png";
import dubbing_img from "../assets/images/searchIcon/dubbing_img.png";
import profile1 from "../assets/images/profile/course_profile.png";
import profile2 from "../assets/images/profile/profile.png";
import appliance from "../assets/images/searchIcon/appliance.png";
import furniture from "../assets/images/searchIcon/furniture.png";
import packersMovers from "../assets/images/searchIcon/Packers and movers.png";

export const image = {
  logo,
  logo1,
  headerLogo,
  searchIcon,
  product01,
  imageUpload,
  
  needHelp,
  dubbing_img,
  profile1,
  profile2,
  appliance,
  furniture,
  packersMovers,
};
